module.exports = __webpack_public_path__ + "static/img-3-028737808e368dbb6beb166b94166b85.jpeg";